import { EntityModel } from '@/interfaces'
import {
  ALL_FORM_BLOCKS_QUERY,
  CREATE_FORM_BLOCK_MUTATION,
  DELETE_FORM_BLOCK_MUTATION,
  FORCE_DELETE_FORM_BLOCK_MUTATION,
  SINGLE_FORM_BLOCK_QUERY,
  UPDATE_FORM_BLOCK_MUTATION,
} from './graphql'

const cmsFormBlockModel: EntityModel = {
  name: 'formBlock',
  namePlural: 'formBlocks',
  uniqueName: 'cmsFormBlock',
  uniqueNamePlural: 'cmsFormBlocks',
  path: 'cms/blocks/form_block',
  baseUrl: '/cms/blocks/form_blocks',
  translationPrefix: 'entities:cmsFormBlock.',
  getDisplayName: (values: any) => {
    return 'CMS Form Block'
  },
  gql: {
    getAll: ALL_FORM_BLOCKS_QUERY,
    getSingle: SINGLE_FORM_BLOCK_QUERY,
    create: CREATE_FORM_BLOCK_MUTATION,
    update: UPDATE_FORM_BLOCK_MUTATION,
    delete: DELETE_FORM_BLOCK_MUTATION,
    forceDelete: FORCE_DELETE_FORM_BLOCK_MUTATION,
  },
  attributes: {
    formName: {
      name: 'formName',
      label: 'entities:cmsFormBlock.attributes.formName.label',
      type: 'value',
      dataType: 'string',
      defaultValue: 'contact',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsFormBlockModel
